module.exports = __webpack_public_path__ + "static/img/Top Logo_black.80f5341.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/svg/Top Logo_black.svg
// module id = yDev
// module chunks = 5